'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

function isNaN(value) {
    return Number.isNaN(value);
}

exports.isNaN = isNaN;
